import {Button} from "@twigsby/frontend-framework";
import React from "react";
import {useTranslation} from "@twigsby/frontend-framework";

type SelectEverythingBannerType = {
    selectedCount: number;
    selectedLabel: string;
    callback: () => void;
}

const SelectEverythingBanner = (props: SelectEverythingBannerType) => {
    const { t } = useTranslation();

    return (
        <div className={'select-everything-banner'}>
            {t('counts.selectedItems', {count: props.selectedCount})}
            <Button title={props.selectedLabel} onClick={() => props.callback()} />
        </div>
    )
}

export default SelectEverythingBanner
